import { render, staticRenderFns } from "./MemberLoans.vue?vue&type=template&id=50ad4046"
import script from "./MemberLoans.vue?vue&type=script&lang=js"
export * from "./MemberLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports